import { render, staticRenderFns } from "./RaceImage.vue?vue&type=template&id=0aa6e55b&scoped=true&"
import script from "./RaceImage.vue?vue&type=script&lang=js&"
export * from "./RaceImage.vue?vue&type=script&lang=js&"
import style0 from "./RaceImage.vue?vue&type=style&index=0&id=0aa6e55b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa6e55b",
  null
  
)

export default component.exports